// @core/api/endpoints/subscription/create_discount.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateDiscountRequest,
  DiscountResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Create a discount code
 * Creates a new discount code for subscriptions. Supports percentage or fixed discounts, usage limits, and plan restrictions.
 */
export async function CreateDiscount(
  data: CreateDiscountRequest,
  options?: RequestOptions
): Promise<DiscountResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/discounts`;
  const requestOptions = options;
  return client.post<DiscountResponse>(requestPath, data, requestOptions);
}
